<template>
  <main>
    <CRow>
      <CCol col="12">
        <div class="flex-center">
          <div class="flex">
            <div>
              <CButton class="btn_dia" size="sm" @click="anterior">
                <CIcon name="cil-arrow-left" />
              </CButton>
              <CButton class="btn_dia" size="sm" @click="proximo">
                <CIcon name="cil-arrow-right" />
              </CButton>
            </div>
            <h2 class="dia_titulo">{{ dia }}</h2>
          </div>
          <div class="flex">
            <CInput
              type="date"
              v-model="dataBusca"
              @change="selecionaData()"
            ></CInput>
          </div>
        </div>
      </CCol>

      <CCol col="4" v-for="(hora, index) of agenda" :key="index">
        <CCard>
          <CCardHeader>
            <h2>Sala - {{ hora.sala }}</h2>
          </CCardHeader>
          <CCardBody v-for="(item, index) of hora.data" :key="index">
            <h2>{{ item.name }}</h2>
            <CDataTable
              :items="item.horarios"
              :fields="fields"
              clickableRows
              @row-clicked="clickHorario($event, item, hora.sala)"
              id="table_horarios"
            >
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </main>
</template>
<script>
import moment from "moment";
import "moment/locale/pt-br";

export default {
  data() {
    return {
      dia: moment().format("dddd DD/MM/YYYY"),
      agenda: [],

      fields: [
        { key: "name", label: "Nome", _style: "min-width:50px;" },
        { key: "status", label: "Estado", _style: "min-width:50px;" },
        {
          key: "patient",
          label: "Paciente",
          _style: "min-width:100px;",
          sorter: false,
          filter: false,
        },
      ],
      dataBusca: "",
    };
  },
  methods: {
    removerAcentosTrocarHifens(str) {
      var strSemAcentos = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      var strComUnderscores = strSemAcentos.replace(/-/g, "_");
      return strComUnderscores;
    },

    buscarDados() {},
    anterior() {
      try {
        this.dia = moment(this.dia, "dddd DD/MM/YYYY")
          .subtract(1, "day")
          .format("dddd DD/MM/YYYY");

        const nomeDia = this.removerAcentosTrocarHifens(
          moment(this.dia, "dddd DD/MM/YYYY").format("dddd")
        );
        this.dataBusca = moment(this.dia, "dddd DD/MM/YYYY").format(
          "YYYY-MM-DD"
        );

        
        if (nomeDia == "domingo") {
          this.agenda == null;
          throw new Error("Domingo");
        }
        const data = moment(this.dia, "dddd DD/MM/YYYY").format("YYYY-MM-DD");

        this.$http
          .post(`${process.env.VUE_APP_API_BASE_URL}salas-profissional`, {
            nomeDia,
            data,
          })
          .then((res) => res.json())
          .then((res) => {
            this.agenda = res;

            this.agenda.forEach((elem) => {
              elem.data.forEach((item) => {
                item.horarios.forEach((item) => {
                  if (item.status == "ocupado") {
                    item._classes = "table-danger";
                  }
                  if (item.patient == null) {
                    item.patient = "-";
                  }
                });
              });
            });

            for (let i = 0; i < this.agenda.length; i++) {
            
            for (let j = 0; j < this.agenda[i].data.length; j++) {
              for (let c = 0; c < this.agenda[i].data[j].horarios.length - 1; c++) {
                  if (this.agenda[i].data[j].horarios[c].status == "ocupado" && this.agenda[i].data[j].horarios[c].consult_time == "1") {
                  this.agenda[i].data[j].horarios.splice(c+1,1)
                }
              }
            }
          }
          });
      } catch (error) {
        
        this.agenda = null;
      }
    },
    proximo() {
      try {
        this.dia = moment(this.dia, "dddd DD/MM/YYYY")
          .add(1, "day")
          .format("dddd DD/MM/YYYY");

        const nomeDia = this.removerAcentosTrocarHifens(
          moment(this.dia, "dddd DD/MM/YYYY").format("dddd")
        );
        this.dataBusca = moment(this.dia, "dddd DD/MM/YYYY").format(
          "YYYY-MM-DD"
        );
        if (nomeDia == "domingo") {
          throw new Error("é domingo");
        }
        const data = moment(this.dia, "dddd DD/MM/YYYY").format("YYYY-MM-DD");

        this.$http
          .post(`${process.env.VUE_APP_API_BASE_URL}salas-profissional`, {
            nomeDia,
            data,
          })
          .then((res) => res.json())
          .then((res) => {
            this.agenda = res;
            this.agenda.forEach((elem) => {
              elem.data.forEach((item) => {
                item.horarios.forEach((item) => {
                  if (item.status == "ocupado") {
                    item._classes = "table-danger";
                  }
                  if (item.patient == null) {
                    item.patient = "-";
                  }
                });
              });
            });
            for (let i = 0; i < this.agenda.length; i++) {
            
            for (let j = 0; j < this.agenda[i].data.length; j++) {
              for (let c = 0; c < this.agenda[i].data[j].horarios.length - 1; c++) {
                  if (this.agenda[i].data[j].horarios[c].status == "ocupado" && this.agenda[i].data[j].horarios[c].consult_time == "1") {
                  this.agenda[i].data[j].horarios.splice(c+1,1)
                }
              }
            }
          }
          });
      } catch (error) {
        this.agenda = null;
      }
    },
    init() {
      const nomeDia = this.removerAcentosTrocarHifens(
        moment(this.dia, "dddd DD/MM/YYYY").format("dddd")
      );
      const data = moment(this.dia, "dddd DD/MM/YYYY").format("YYYY-MM-DD");

      this.$http
        .post(`${process.env.VUE_APP_API_BASE_URL}salas-profissional`, {
          nomeDia,
          data,
        })
        .then((res) => res.json())
        .then((res) => {
          this.agenda = res;

          this.agenda.forEach((elem) => {
            elem.data.forEach((item) => {
              item.horarios.forEach((item) => {
                if (item.status == "ocupado") {
                  item._classes = "table-danger";
                }
                if (item.patient == null) {
                  item.patient = "-";
                }
              });
            });
          });
          
          for (let i = 0; i < this.agenda.length; i++) {
            
            for (let j = 0; j < this.agenda[i].data.length; j++) {
              for (let c = 0; c < this.agenda[i].data[j].horarios.length - 1; c++) {
                  if (this.agenda[i].data[j].horarios[c].status == "ocupado" && this.agenda[i].data[j].horarios[c].consult_time == "1") {
                  this.agenda[i].data[j].horarios.splice(c+1,1)
                }
              }
            }
          }
        });
    },
    clickHorario(item, hora, sala) {
      if (item.status == "disponivel") {
        this.$router.push({
          name: "Consultas",
          query: { id: "", type: "a" },
          params: {
            voltar: "calendario/listar",
            item,
            hora,
            sala,
            dia: this.dia,
          },
        });
      } else {
        this.$router.push({
          path: `consultas`,
          name: "Consultas",
          query: { id: item.idConsulta, type: "b" },
        });
      }
    },
    selecionaData() {
      
      try {
        const nomeDia = this.removerAcentosTrocarHifens(
          moment(this.dataBusca, "YYYY-MM-DD").format("dddd")
        );

        if (nomeDia == "domingo") {
          this.dia = moment(this.dataBusca, "YYYY-MM-DD").format(
            "dddd DD/MM/YYYY"
          );
          throw new Error("é domingo");
        }
        
        const data = this.dataBusca;

        this.$http
          .post(`${process.env.VUE_APP_API_BASE_URL}salas-profissional`, {
            nomeDia,
            data,
          })
          .then((res) => res.json())
          .then((res) => {
            this.agenda = res;
            this.agenda.forEach((elem) => {
              elem.data.forEach((item) => {
                item.horarios.forEach((item) => {
                  if (item.status == "ocupado") {
                    item._classes = "table-danger";
                  }
                  if (item.patient == null) {
                    item.patient = "-";
                  }
                });
              });
            });
          })
          .then((res) => {
            this.dia = moment(this.dataBusca, "YYYY-MM-DD").format(
              "dddd DD/MM/YYYY"
            );
          });
      } catch (error) {
        this.agenda = null;
      }
    },
  },
  mounted() {
    moment.locale("pt-br");
    this.init();
    this.dataBusca = moment(new Date()).format("YYYY-MM-DD");
  },
};
</script>
<style scoped>
.flex-center {
  margin: 0 auto;
  width: 700px;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 4rem;
}
.dia_titulo {
  text-transform: capitalize;
}

.btn_dia {
  background: #2c3e50;
  color: white;
  border-radius: 0px;
  padding: 0.5rem;
}

table tbody tr {
  background-color: #2c3e50 !important;
}
.flex {
  display: flex;
  gap: 2rem;
  justify-items: center;
}
</style>
